import React from 'react'

import { Tag } from '@icontainers/design-system/dist/molecules/Tag'
import { IconDescriptionLink } from '@src/Application/Types/HeaderTypes'

import { Description, Icon, Link, Title, TitleWraper, Wrapper } from './ActionItemWithIcon.styled'

export const ActionItemWithIcon = (props: IconDescriptionLink): JSX.Element => {
    const { tag, description, name, icon, url, onClick } = props

    const content = (
        <Wrapper onClick={onClick} $mb={!url}>
            {icon && <Icon image={icon} loading="eager" />}
            <TitleWraper>
                {name && <Title>{name}</Title>}
                {description && <Description>{description}</Description>}
                {tag && (
                    <Tag color="voilet" noBorder>
                        {tag}
                    </Tag>
                )}
            </TitleWraper>
        </Wrapper>
    )

    if (url) {
        return <Link to={url}>{content}</Link>
    }

    return content
}
